import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { AppSettings } from '../../PRE-LOAD/app-settings';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { buildUrl } from '../../../../urls';

@Injectable({
    providedIn: 'root'
})
export class StringsService {

    saved;
    obs;

    constructor(
        private httpClient: HttpClient,
        private appSettings: AppSettings
    ) {
    }

    /**
     * @description Get string data from local JSON file
     * @returns Returns an object of strings
     */
    public get(): Observable<any> {
        if (this.saved) {
            return of(this.saved);
        }
        if (this.obs) {
            return this.obs;
        }
        return this.obs = this.httpClient.get(
            // What if content root url is empty?
            buildUrl(this.appSettings.contentRootUrl, `assets/data/strings.${environment.brand}.json`)
        ).pipe(tap(data => this.saved = data));
    }

}
